var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFoundPage"},[_c('h1',{staticClass:"notFoundCode"},[_vm._v(" 404 ")]),_c('div',{staticClass:"notFoundMessage"},[_vm._v(" Helaas, deze pagina bestaat niet (meer). ")]),_c('b-button',{attrs:{"variant":"primary","href":"/"}},[_vm._v(" Ga naar de thuis pagina ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }